<template>
  <div>
    <v-data-table
			:headers="headers"
			:items="computedRows"
      disable-pagination
      hide-default-footer
			item-key="id"
			class="tablaLT1"
      :class="dark_t?'dark':''">

      <template  v-slot:item="props">
        <slot name="items" v-bind="{props}"></slot>

      </template>
			<template v-slot:no-data>
					<v-icon>warning</v-icon>
					Sin Información.
			</template>
			<template v-slot:expand="props">
        <slot name="items-expand" v-bind="{props}"></slot>
			</template>
		</v-data-table>

    <div class="navegationTable" v-if="pagination" :class="dark_t?'dark':''">
      <div>
        <div class="range" style="margin-right: 15px">
          <div style="display: inline-block;">Filas por pagina</div>
          <v-select
            :menu-props="{ top: true, offsetY: true }"
            style="display: inline-block;margin-left:20px;width: min-content;"
            v-model="navegation.page_size"
            :items="rowsXpage"
            item-text="t"
            item-value="v"/>
        </div>
        <div class="range">
          <span>{{navegationRange}}</span>
        </div>
        <div>
          <button @click="pageChange(navegation.page - 1)"
            :disabled="navegation.page <= 1"
            class="v-btn v-btn--flat v-btn--icon theme--light"
            :class="navegation.page <= 1 &&  'v-btn--disabled'">
            <v-icon>keyboard_arrow_left</v-icon>
          </button>
          <div style="width:25px;display:inline-block"></div>
          <button @click="pageChange(navegation.page + 1)"
            class="v-btn v-btn--flat v-btn--icon theme--light"
            :class="navegation.page >= navegation.pages &&  'v-btn--disabled'"
            :disabled="navegation.page >= navegation.pages">
            
            <v-icon>keyboard_arrow_right</v-icon>
          </button>
        </div>						
      </div>
    </div>
  </div>
</template>

<script>

import Debounce from '@/components/mixins/Debounce.js';

export default {
  mixins: [ Debounce ],
  props:{
    st_key:{},
    pagination:{default:true},
    customGet:{},
    headers:{},
    subHeaders:{},
    name:{},
    gets:{default:()=>()=>{}},
    preFilters:{},
    preFilters__s:{},
    rowsFunction: {},
  },
  data() {
    return {
      selectedItem: {},
      rows: [],
      defaultFilters: {  },
      navegation:{
        page: 1,
        count: 0,
        page_size: 10,
        pages: 0,
      },
      filtersResults: {
        s__name: [],
      },
    };
  },
  computed: {
    requestStatus() {
      const rqs = this.$store.getters.requestStatus;
      return rqs.find(r => r.name === this.name) || {};
    },
    rowsXpage() {
      return [
        {v: 10, t: 10},
        {v: 25, t: 25},
        {v: 10000, t: 'Todas'},
      ];
    },
    filters(){
      const f = Object.assign({}, this.preFilters || {}, this.defaultFilters);
      //this.debounceM('s__name', this.search);
      return f;
    },
    navegationRange(){
      const page = this.navegation.page || 1;
      const pageSize = this.navegation.page_size || 10;
      const count = this.navegation.count || 0;
      if (!count) return `0 - 0 of 0`;
      const start = (page - 1) * pageSize + 1;
      const end = Math.min(page * pageSize, count);
      return `${start} - ${end} of ${count}`;
		},
    computedRows() {
      if(this.rowsFunction) {
        return this.rowsFunction(this.rows);
      } else {
        return this.rows;
      }
    },
  },
  watch:{
		'navegation.page_size'(val){
			this.filters.page_size = val;
			this.pageChange(1)
    },
    'preFilters__s':{
      handler: function(val,old) {
        this.debounceM('s__name', this.search);
      },
			deep:true
    },
    'preFilters':{
      handler: function(val,old) {
        this.navegation.page = 1;
        this.getRows();
      },
			deep:true
		}
  },
  created(){
    if (this.pagination) {
      this.navegation.page = 1;
      this.getRows();
    }
  },
  methods: {
    async getRows(){
      if(!await this.assignAccess()) {
        this.setProgress({show:false});
        this.getError('no se pudo obtener acceso')
        return;
      } // if

      const filters = {};
      Object.keys(this.filters).forEach(key => {
        if(this.filters[key] != null) filters[key] = this.filters[key];
      });
      return this.gets(filters)
        .then(r => {
          if (r && this.pagination) {
            if (r.results) {
              this.navegation.count = r.count;
              this.navegation.pages = this.navegation.count / this.navegation.page_size;
              //this.navegation.pages = r.count / this.navegation.page_size;
              this.navegation.page = this.filters.page || 1;
            }
          }

          const rows = this.pagination ? r.results : r;
          if (this.beforeSetRows) this.beforeSetRows(rows);
          if (this.st_key) this.$store.dispatch('set', {key: this.st_key, val: rows});
          this.rows = rows;
          return r;
        });
    },
    resetRqStatus(){
      this.requestStatus.status = false;
      this.requestStatus.ticking = false;
    },
    pageChange(page){
      Object.assign(this.filters, {page});
      this.resetRqStatus();
			return this.getRows();
		},
    search(key){
      this.pageChange(1)
        .then(r =>{ 
          this.filtersResults[key] = r.results;
        });
    }
  },
};
</script>
